fragment CachedPlanFragment on CachedPlan {
    code
    licenseCount
}
